import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const packageDoc = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    version: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Version - The version the file was read from'),

    path: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe(
        "Path - The file's path inside the package, e.g. docs/design/design.md",
      ),

    title: z
      .string()
      .nullable()
      .optional()
      .describe("Title - The file's first heading, else its file name"),

    content: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Content - The markdown'),

    npmPackageId: z.number().hidden().describe('Foreign key to NpmPackage'),

    npmPackage: belongsTo('NpmPackage'),
  })
  .describe(
    "One markdown file of a package's latest version, kept so the sitewide\nsearch can index it and link straight to the page it lives on. Covers\nthe README, the changelog, everything under `docs/`, and the news file\nfor the version.\nRows are rebuilt by the catalog refresh whenever a package's latest\nversion changes, so a hit never appears once per version.",
  )
  .as('PackageDoc');

export { packageDoc as packageDocSchema };
